<!--  -->
<template>
  <div class="">
    <div class="historychoose">
      <h2>请选择日期范围查询<span>{{ realName }}</span><span style="color:#4da1eb">动态血氧</span>检测记录</h2>
      <el-form ref="form" :model="form">
        <el-col :span="2">
          <div class="blank"></div>
        </el-col>
        <el-form-item>
          <span slot="label">
            <span class="form-name"> 选择起始日期 </span>
          </span>
          <el-col :span="11" class="blank">
            <el-date-picker type="date" placeholder="选择日期" v-model="form.date1" style="width: 100%"></el-date-picker>
          </el-col>
        </el-form-item>
        <el-col :span="2">
          <div class="blank"></div>
        </el-col>
        <el-form-item>
          <span slot="label">
            <span class="form-name"> 选择截止日期 </span>
          </span>
          <el-col :span="11" class="blank">
            <el-date-picker type="date" placeholder="选择日期" v-model="form.date2" style="width: 100%"></el-date-picker>
          </el-col>
        </el-form-item>
        <el-col :span="2">
          <div class="blank"></div>
        </el-col>
        <el-form-item>
          <el-button class="xingou-blue" type="primary" @click="querylistByTime()">确认查询</el-button>
          <el-button type="primary" plain @click="queryAll()">查询所有记录</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" height="600" :header-cell-style="tableHeaderColor" border stripe style="width: 100%"
        :cell-style="{ fontSize: '16px' }" v-loading="loadingShow" element-loading-text="数据正在加载中"
        :default-sort="{ prop: 'createTime', order: 'descending' }">
        <el-table-column type="index" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="监测开始时间" align="center" sortable>
        </el-table-column>
        <el-table-column prop="endTime" label="监测结束时间" align="center">
        </el-table-column>
        <el-table-column prop="totalTime" label="时长" align="center">
        </el-table-column>
        <el-table-column prop="latestSpo2" label="最新血氧(%)" align="center">
        </el-table-column>
        <el-table-column prop="avgSpo2" label="平均血氧(%)" align="center">
        </el-table-column>
        <el-table-column prop="minSpo2" label="最低血氧(%)" align="center">
        </el-table-column>
        <el-table-column prop="maxSpo2" label="最高血氧(%)" align="center">
        </el-table-column>
        <el-table-column prop="latestPr" label="最新脉率" align="center">
        </el-table-column>
        <el-table-column prop="avgPr" label="平均脉率" align="center">
        </el-table-column>
        <el-table-column prop="read" label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="medium"
              style="font-size: 16px;">查看记录</el-button>
          </template>
        </el-table-column>
        <el-table-column label="删除" align="center">
          <template slot-scope="scope">
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelete(scope.$index, scope.row)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        date1: '',
        date2: '',
      },
      tableData: [],
      loadingShow: true,
      realName: '',
      uid: '',
    };
  },
  methods: {
    TimeProcess(time) {
      let y = time.getFullYear();
      let MM = time.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = time.getDate();
      d = d < 10 ? ('0' + d) : d;
      return y + '-' + MM + '-' + d;
    },
    formatDuration(seconds) {
      let d = Math.floor(seconds / 86400);
      let h = Math.floor((seconds % 86400) / 3600);
      let m = Math.floor((seconds % 3600) / 60);
      let s = seconds % 60;
      if (d > 0) return d + '天' + h + '小时' + m + '分';
      if (h > 0) return h + '小时' + m + '分';
      if (m > 0) return m + '分' + s + '秒';
      return s + '秒';
    },
    processTableData(list) {
      return list.map(item => ({
        ...item,
        totalTime: this.formatDuration(item.duration),
      }));
    },
    querylistByTime() {
      if (!this.form.date1) {
        this.$message.warning('请选择起始日期');
        return;
      }
      if (!this.form.date2) {
        this.form.date2 = new Date();
      }
      this.loadingShow = true;
      const startTime = this.TimeProcess(this.form.date1) + ' 00:00:00';
      const endTime = this.TimeProcess(this.form.date2) + ' 23:59:59';
      this.$http({
        url: this.$http.adornUrl('/personal/personaldynamicbloodoxygen/app/list'),
        method: 'post',
        data: this.$http.adornData({ uid: this.uid, startTime, endTime }),
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.loadingShow = false;
          this.tableData = this.processTableData(data.data || []);
        } else {
          this.loadingShow = false;
          this.$message.error(data.msg);
        }
      });
    },
    queryAll() {
      this.loadingShow = true;
      this.$http({
        url: this.$http.adornUrl('/personal/personaldynamicbloodoxygen/app/list'),
        method: 'post',
        data: this.$http.adornData({ uid: this.uid, startTime: '2001-01-01 00:00:00', endTime: '2030-12-31 23:59:59' }),
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.loadingShow = false;
          this.tableData = this.processTableData(data.data || []);
        } else {
          this.loadingShow = false;
          this.$message.error(data.msg);
        }
      });
    },
    handleClick(row) {
      this.$router.push({
        name: 'HistoryDynamicBloodOxygen2',
        query: {
          id: row.id,
          uid: row.uid,
          RecordCreatetime: row.createTime,
          totalTime: row.totalTime,
        },
      });
    },
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.tableData.splice(index, 1);
        this.$message({ type: 'success', message: '删除成功!' });
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' });
      });
    },
    tableHeaderColor() {
      return 'color:#000 ;font-size:18px;text-align:center';
    },
    getinfo() {
      this.$http({
        url: this.$http.adornUrl('/personal/info/getBasicInfo'),
        method: 'get',
        params: this.$http.adornParams({ uid: this.uid }),
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.realName = data.realName;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
  },
  created() {
    if (this.$route.query.crossPlatform != null && this.$route.query.crossPlatform != undefined) {
      this.crossPlatformStatus = true;
    }
    if (this.$route.query.uid) {
      this.uid = this.$route.query.uid;
    } else {
      this.uid = this.$store.state.personal_module.uid;
    }
  },
  mounted() {
    this.queryAll();
    this.getinfo();
  },
};
</script>

<style scoped>
.blank {
  border-radius: 4px;
  height: 18px;
}

.form-name {
  display: inline-block;
  font-weight: bold;
  font-size: 18px;
}

.xingou-blue {
  color: #fff;
  background-color: #428bca;
  border-color: #428bca;
}

.xingou-blue:hover,
.xingou-blue:focus {
  background: #4da1eb;
  border-color: #4da1eb;
  color: #fff;
}
</style>
